function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "w"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  d: "M313.1,41.7c0,17-13.8,30.8-30.7,30.8c-17,0-30.8-13.8-30.8-30.7 c0-17,13.8-30.8,30.7-30.8c0,0,0,0,0,0C299.4,10.9,313.1,24.7,313.1,41.7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  d: "M350.8,178.6l-23.8-90.6c0,0,0-0.1,0-0.1c-0.8-4-4.3-7-8.4-7h-72.2c-4.1,0-7.7,2.9-8.4,7 c0,0,0,0.1,0,0.1L214,178.6c-1.3,5.1,1.7,10.3,6.8,11.6s10.3-1.7,11.6-6.8l0,0l19.3-73.3v41l-18.7,71.2h18.7v71.8 c-0.1,6.7,5.1,12.2,11.8,12.4c6.7,0.1,12.2-5.1,12.4-11.8c0-0.2,0-0.4,0-0.5v-71.7h13.1v71.7c0.1,6.7,5.7,12,12.3,11.9 c6.5-0.1,11.7-5.4,11.9-11.9v-71.7h18.7l-18.7-71.2v-41.1l19.3,73.3c1.3,5.1,6.5,8.1,11.6,6.8C349.1,188.9,352.1,183.7,350.8,178.6 L350.8,178.6z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "m"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  d: "M480,35c0,17.4-14.1,31.5-31.5,31.5c-17.4,0-31.5-14.1-31.5-31.5 c0-17.4,14.1-31.5,31.5-31.5C465.8,3.4,480,17.6,480,35z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  d: "M494.4,75.3h-92c-5.4,0-9.7,4.4-9.7,9.7v95.7c-0.1,5.4,4.1,9.8,9.4,10.1 c5.4,0.2,9.9-4.1,10-9.4c0-0.1,0-0.2,0-0.3v-84c0-1.3,1.1-2.4,2.4-2.4c0,0,0,0,0,0l0,0c1.3,0,2.4,1.1,2.4,2.4c0,0,0,0,0,0v196.4 c-0.1,6.6,5,12.2,11.6,12.8c6.8,0.5,12.8-4.7,13.2-11.6c0-0.3,0-0.6,0-0.8V190.8h13.4v102.7c-0.1,6.6,5,12.2,11.6,12.8 c6.8,0.5,12.8-4.7,13.2-11.6c0-0.3,0-0.5,0-0.8V97.1c0-1.3,1.1-2.4,2.4-2.4c0,0,0,0,0,0l0,0c1.3,0,2.4,1.1,2.4,2.4c0,0,0,0,0,0 v83.6c-0.1,5.4,4.1,9.8,9.4,10.1c5.4,0.2,9.9-4.1,10-9.4c0-0.1,0-0.2,0-0.3V85C504.2,79.7,499.8,75.3,494.4,75.3z"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  className: "m"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  d: "M663.1,35c0,17.4-14.1,31.5-31.5,31.5c-17.4,0-31.5-14.1-31.5-31.5 c0-17.4,14.1-31.5,31.5-31.5S663.1,17.6,663.1,35C663.1,35,663.1,35,663.1,35z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  d: "M677.6,75.3h-92c-5.4,0-9.7,4.4-9.7,9.7c0,0,0,0,0,0v95.7c-0.1,5.4,4.1,9.8,9.4,10.1 c5.4,0.2,9.9-4.1,10-9.4c0-0.1,0-0.2,0-0.3v-84c0-1.3,1.1-2.4,2.4-2.4c0,0,0,0,0,0l0,0c1.3,0,2.4,1.1,2.4,2.4c0,0,0,0,0,0v196.4 c-0.1,6.6,5,12.2,11.6,12.8c6.8,0.5,12.8-4.7,13.2-11.6c0-0.3,0-0.6,0-0.8V190.8h13.4v102.7c-0.1,6.6,5,12.2,11.6,12.8 c6.8,0.5,12.8-4.7,13.2-11.6c0-0.3,0-0.6,0-0.8V97.1c0-1.3,1.1-2.4,2.4-2.4c0,0,0,0,0,0l0,0c1.3,0,2.4,1.1,2.4,2.4c0,0,0,0,0,0 v83.6c-0.1,5.4,4.1,9.8,9.4,10.1c5.4,0.2,9.9-4.1,10-9.4c0-0.1,0-0.2,0-0.3V85C687.3,79.7,683,75.3,677.6,75.3z"
}));

function SvgW1M2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 901 310",
    enableBackground: "new 0 0 901 310",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgW1M2);
export default __webpack_public_path__ + "static/media/w1-m2.a08c96fc.svg";
export { ForwardRef as ReactComponent };